import Button from 'primevue/button'
import Card from 'primevue/card'
import Select from 'primevue/select'
import MultiSelect from 'primevue/multiselect'
import IconField from 'primevue/iconfield'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputIcon from 'primevue/inputicon'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Menu from 'primevue/menu'
import Skeleton from 'primevue/skeleton'
import TabMenu from 'primevue/tabmenu'
import Tooltip from 'primevue/tooltip'
import Divider from 'primevue/divider'
import Checkbox from 'primevue/checkbox'
import RadioButton from 'primevue/radiobutton'
import SelectButton from 'primevue/selectbutton'
import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import TabPanel from 'primevue/tabpanel'
import TabPanels from 'primevue/tabpanels'
import Tab from 'primevue/tab'
import Message from 'primevue/message'
import Tag from 'primevue/tag'
import Dialog from 'primevue/dialog'
import Paginator from 'primevue/paginator'
import ToggleSwitch from 'primevue/toggleswitch'

/** Компоненты, нужные client / courier / restaurant / admin. */
export function registerCommonPrimeVue(app) {
  app.component('PButton', Button)
  app.component('PIconField', IconField)
  app.component('PInputIcon', InputIcon)
  app.component('PInputText', InputText)
  app.component('PInputNumber', InputNumber)
  app.component('PInputGroup', InputGroup)
  app.component('PInputGroupAddon', InputGroupAddon)
  app.component('PSelect', Select)
  app.component('PMultiSelect', MultiSelect)
  app.component('PCard', Card)
  app.component('PMenu', Menu)
  app.component('PTabMenu', TabMenu)
  app.component('PSkeleton', Skeleton)
  app.directive('tooltip', Tooltip)
  app.component('PDivider', Divider)
  app.component('PCheckbox', Checkbox)
  app.component('PRadioButton', RadioButton)
  app.component('PSelectButton', SelectButton)
  app.component('PTabs', Tabs)
  app.component('PTabList', TabList)
  app.component('PTab', Tab)
  app.component('PTabPanels', TabPanels)
  app.component('PTabPanel', TabPanel)
  app.component('PMessage', Message)
  app.component('PTag', Tag)
  app.component('PDialog', Dialog)
  app.component('PPaginator', Paginator)
  app.component('PToggleSwitch', ToggleSwitch)
}
